import _extends from "@babel/runtime/helpers/esm/extends";
import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
import { DEFAULT_EVENT_CALENDAR_PREFERENCES } from "../use-event-calendar/EventCalendarStore.mjs";
const allPreferencesSelector = createSelectorMemoized(state => state.preferences, preferences => _extends({}, DEFAULT_EVENT_CALENDAR_PREFERENCES, preferences));
export const eventCalendarPreferenceSelectors = {
  all: allPreferencesSelector,
  menuConfig: createSelector(state => state.preferencesMenuConfig),
  ampm: createSelector(allPreferencesSelector, preferences => preferences.ampm),
  showWeekends: createSelector(allPreferencesSelector, preferences => preferences.showWeekends),
  showWeekNumber: createSelector(allPreferencesSelector, preferences => preferences.showWeekNumber),
  showEmptyDaysInAgenda: createSelector(allPreferencesSelector, preferences => preferences.showEmptyDaysInAgenda),
  isSidePanelOpen: createSelector(allPreferencesSelector, preferences => preferences.isSidePanelOpen)
};